module.exports = __webpack_public_path__ + "img/microsite-header.beeacbb3.gif";